module.exports = __webpack_public_path__ + "static/media/almenekurser.8980b9df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Courses/almenekurser.jpg
// module id = 1525
// module chunks = 0